import React, { useRef } from 'react';
import useFullscreen from '../hooks/useFullscreen';
import useIframeWatchdog from '../hooks/useIframeWatchdog';

function BankeCapital() {
  const pageRef = useRef(null);
  const { isFullscreen, toggleFullscreen } = useFullscreen(pageRef);
  const videoId = 'nC22zvrLyNE';
  const src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&modestbranding=1&rel=0&playsinline=1`;
  const { iframeSrc } = useIframeWatchdog(src);

  return (
    <div
      ref={pageRef}
      className="bankecapital-video-page"
      onDoubleClick={toggleFullscreen}
    >
      <iframe
        className="bankecapital-video-frame"
        src={iframeSrc}
        title="Banke Capital video"
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      />
      <div
        className="bankecapital-overlay"
        onDoubleClick={toggleFullscreen}
        aria-label="Double click to toggle fullscreen"
      />
      <button
        type="button"
        className="fullscreen-toggle-button"
        onClick={toggleFullscreen}
        aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
      >
        {isFullscreen ? 'EX' : 'FS'}
      </button>

      <style>{`
        html, body, #root {
          width: 100%;
          height: 100%;
          margin: 0;
          overflow: hidden;
          background: #000;
        }

        .bankecapital-video-page {
          position: fixed;
          inset: 0;
          background: #000;
          overflow: hidden;
        }

        .bankecapital-video-frame {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100vw;
          height: 56.25vw;
          min-width: 177.78vh;
          min-height: 100vh;
          transform: translate(-50%, -50%);
          border: 0;
          pointer-events: none;
        }

        .bankecapital-overlay {
          position: absolute;
          inset: 0;
          z-index: 2;
          background: transparent;
          cursor: default;
        }

        .fullscreen-toggle-button {
          position: absolute;
          top: 12px;
          right: 12px;
          z-index: 3;
          width: 34px;
          height: 34px;
          border: 1px solid rgba(255, 255, 255, 0.75);
          border-radius: 6px;
          background: rgba(0, 0, 0, 0.45);
          color: #fff;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.5px;
          cursor: pointer;
          padding: 0;
        }
      `}</style>
    </div>
  );
}

export default BankeCapital;
